import React from 'react';
import styles from './HeroSection.module.css';

const HeroSection = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.backgroundGradient}></div>
      <div className={styles.container}>
        <div className={styles.splitLayout}>
          <div className={styles.copyColumn}>
            <span className={styles.badge}>Private Beta · Underwriting Workflow</span>
            <h1 className={styles.headline}>
              Turn case materials into a repeatable underwriting record.
            </h1>
            <p className={styles.subheadline}>
              VerdeKai helps litigation finance teams organize documents, surface missing inputs,
              pressure-test assumptions, and prepare committee-ready work product.
            </p>
            <p className={styles.humanNote}>
              AI helps organize and draft. Analysts own conclusions.
            </p>

            <div className={styles.ctaGroup}>
              <a
                href="mailto:support@verdekai.com?subject=VerdeKai%20Beta%20Access"
                className={styles.primaryCta}
              >
                Request Beta Access
              </a>
              <a href="/login" className={styles.secondaryCta}>Client Portal</a>
            </div>
          </div>

          <div className={styles.visualColumn}>
            <div className={styles.artifactCard} aria-label="Matter dossier artifact preview">
              <div className={styles.artifactHeader}>
                <span className={styles.artifactEyebrow}>Matter Dossier</span>
                <span className={styles.artifactStatus}>Human review</span>
              </div>
              <div className={styles.artifactTitle}>Meridian v. CrestPoint</div>
              <div className={styles.artifactMeta}>
                <span>41 documents</span>
                <span>7 open inputs</span>
                <span>12 evidence links</span>
              </div>
              <div className={styles.artifactSection}>
                <span className={styles.artifactLabel}>Open diligence</span>
                <div className={styles.diligenceRow}>
                  <span className={styles.dotWarning}></span>
                  <span>Damages model requires source support</span>
                </div>
                <div className={styles.diligenceRow}>
                  <span className={styles.dotCopper}></span>
                  <span>Counterparty solvency still provisional</span>
                </div>
              </div>
              <div className={styles.evidenceList}>
                <div className={styles.evidenceRow}>
                  <span>Source-linked note</span>
                  <strong>Pleading ¶18</strong>
                </div>
                <div className={styles.evidenceRow}>
                  <span>Assumption to test</span>
                  <strong>Base damages</strong>
                </div>
                <div className={styles.evidenceRow}>
                  <span>Packet status</span>
                  <strong>Drafted</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
